import React, { useState } from 'react';
import {
  PrimaryButton,
  DefaultButton
} from '@fluentui/react/lib/Button';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { DirectionalHint } from '@fluentui/react/lib/Callout';
import ExportButtonComponent from '../ExportButtonComponent';
import LeaveCommunityComponent from '../LeaveCommunityComponent';
import DeleteDialogCommunityComponent from '../DeleteDialogCommunityComponent/';

interface Props {
  community: any;
  profile: any;
  isExporting: boolean;
  constants: any;
  showManagementTools: boolean;
  isSidePanel?: boolean;
  closeCommunityPanel(): void,
  startEditInviteMembers(communityId: string): void,
  startEditCommunity(community: any): void,
  startEditManage(community: any): void,
  exportCommunityMemberCsv(communityId: string): void,
  exportCommunityInvitesCsv(communityId: string): void,
  requestCloseCommunity(communityId: string): void,
  requestDeleteMember(communityId: string, id: string, flag: boolean, communityName?: string): Promise<boolean>;
  requestLeaveCommunity(communityId: string, id: string, flag: boolean, communityName?: string): Promise<boolean>,
  requestViewCommunityMembers(azureId: string): void;
  startJoinMember(communityId: string, communityType: string, flag: boolean): void,
}

const CommunityActionsComponent = (props: Props) => {
  const [hideDeleteDialog, setHideDeleteDialog] = useState<boolean>(true);

  const {
    community,
    profile,
    constants,
    isSidePanel = false,
    showManagementTools,
    isExporting,
    closeCommunityPanel,
    requestCloseCommunity,
    requestLeaveCommunity,
    startEditInviteMembers,
    requestViewCommunityMembers,
    // requestDeleteMember,
    startEditCommunity,
    exportCommunityMemberCsv,
    exportCommunityInvitesCsv,
    startJoinMember,
    startEditManage,
  } = props;
  console.log('showManagementTools', showManagementTools);
  console.log('community', community);

  const inviteMembers = () => {
    closeCommunityPanel();
    startEditInviteMembers(community.communityId);
  };

  const leaveCommunity = async () => {
    closeCommunityPanel();
    return await requestLeaveCommunity(
        community.communityId,
        profile?.id,
        !showManagementTools,
        community.displayName,
    );
  };

  const editCommunity = () => {
    closeCommunityPanel();
    startEditCommunity(community);
  };

  const showDeleteDialog = () => {
    setHideDeleteDialog(false);
  };

  const exportCommunity = () => {
    closeCommunityPanel();
    exportCommunityMemberCsv(community.communityId);
  };

  const exportCommunityInvites = () => {
    closeCommunityPanel();
    exportCommunityInvitesCsv(community.communityId);
  };

  const closeCommunity = () => {
    requestCloseCommunity(community.communityId);
    closeCommunityPanel();
  };

  const requestToJoin = () => {
    startJoinMember(
      community.communityId,
      community.communityType,
      !showManagementTools
    );

    if (community.communityType === 'Closed') {
      closeCommunityPanel();
    }
  };

  const manageCommunity = () => {
    closeCommunityPanel();
    startEditManage(community);
  };

  const viewMembers = () => {
    requestViewCommunityMembers(community.communityAzureId);
  };

  return (
    <>
      {community && community.isCreated ? (
        <React.Fragment>
          <div>
            <DefaultButton
              iconProps={{
                iconName: 'People',
                styles: {
                  root: {
                    fontSize: 24,
                    height: 24,
                    width: 24,
                    lineHeight: 24,
                    backgroundColor: '#eaeaea',
                    boxSizing: 'content-box',
                    marginLeft: 0,
                    padding: 8,
                    borderRadius: 8
                  }
                }
              }}
              text={`${community.totalMembers} Members`}
              onClick={viewMembers}
              styles={{
                root: {
                  backgroundColor: 'transparent',
                  height: 40,
                  paddingLeft: 0
                },
                rootHovered: {
                  backgroundColor: 'transparent'
                }
              }}
            />
          </div>
          {community.isMember && !community.isOwner && (
            <div>
              <LeaveCommunityComponent
                tooltipProps={{
                  content: constants.LEAVE,
                }}
                title={constants.LEAVE}
                buttonProps={{
                  ariaLabel: constants.LEAVE,
                  disabled: !community.isCreated,
                }}
                community={community}
                onClickAction={leaveCommunity}
                dialogMessage={constants.LEAVE_MESSAGE}
              />
            </div>
          )}
          {community.isMember && community.isOwner && (
            <div>
              <TooltipHost
                content={constants.INVITE}
                directionalHint={DirectionalHint.leftTopEdge}
              >
                <DefaultButton
                  iconProps={{
                    iconName: 'Group',
                    styles: {
                      root: {
                        fontSize: 24,
                        height: 24,
                        width: 24,
                        lineHeight: 24,
                        backgroundColor: '#eaeaea',
                        boxSizing: 'content-box',
                        marginLeft: 0,
                        padding: 8,
                        borderRadius: 8
                      }
                    }
                  }}
                  text='Invite members'
                  ariaLabel={constants.INVITE}
                  onClick={inviteMembers}
                  disabled={!community.isCreated}
                  styles={{
                    root: {
                      backgroundColor: 'transparent',
                      height: 40,
                      paddingLeft: 0
                    },
                    rootHovered: {
                      backgroundColor: 'transparent'
                    }
                  }}
                />
              </TooltipHost>
            </div>
          )}
          {community.isOwner && [
            <div key='edit'>
              <TooltipHost
                content={constants.EDIT}
                directionalHint={DirectionalHint.leftTopEdge}
              >
                <DefaultButton
                  iconProps={{
                    iconName: 'Edit',
                    styles: {
                      root: {
                        fontSize: 24,
                        height: 24,
                        width: 24,
                        lineHeight: 24,
                        backgroundColor: '#eaeaea',
                        boxSizing: 'content-box',
                        marginLeft: 0,
                        padding: 8,
                        borderRadius: 8
                      }
                    }
                  }}
                  text='Edit community'
                  ariaLabel={constants.EDIT}
                  onClick={editCommunity}
                  disabled={!community.isCreated}
                  styles={{
                    root: {
                      backgroundColor: 'transparent',
                      height: 40,
                      paddingLeft: 0
                    },
                    rootHovered: {
                      backgroundColor: 'transparent'
                    }
                  }}
                />
              </TooltipHost>
            </div>,
            <div key='close'>
              <TooltipHost
                content={constants.CLOSE}
                directionalHint={DirectionalHint.leftTopEdge}
              >
                <DefaultButton
                  iconProps={{
                    iconName: 'Delete',
                    styles: {
                      root: {
                        fontSize: 24,
                        height: 24,
                        width: 24,
                        lineHeight: 24,
                        backgroundColor: '#eaeaea',
                        boxSizing: 'content-box',
                        marginLeft: 0,
                        padding: 8,
                        borderRadius: 8
                      }
                    }
                  }}
                  text='Close community'
                  ariaLabel={constants.CLOSE}
                  disabled={!community.isCreated}
                  onClick={showDeleteDialog}
                  styles={{
                    root: {
                      backgroundColor: 'transparent',
                      height: 40,
                      paddingLeft: 0
                    },
                    rootHovered: {
                      backgroundColor: 'transparent'
                    }
                  }}
                />
              </TooltipHost>
            </div>,
            <div key='export' className='display-flex'>
              <ExportButtonComponent
                tooltipProps={{
                  content: constants.EXPORT,
                }}
                title={'Export members'}
                buttonProps={{
                  ariaLabel: constants.EXPORT,
                  disabled: !community.isCreated || isExporting,
                }}
                onClickAction={exportCommunity}
                isExporting={isExporting}
              />
            </div>,
            <div key='exportinvites'>
              <ExportButtonComponent
                tooltipProps={{
                  content: constants.EXPORT_INVITES,
                }}
                title={'Export invites'}
                buttonProps={{
                  ariaLabel: constants.EXPORT_INVITES,
                  disabled: !community.isCreated,
                }}
                onClickAction={exportCommunityInvites}
                isExporting={false}
              />
            </div>,
            <DeleteDialogCommunityComponent
              key={'deleteCommunity'}
              community={community}
              isDialogHidden={hideDeleteDialog}
              setDialogHidden={setHideDeleteDialog}
              title={`Delete '${community.displayName}' community`}
              dialogMessage={constants.POPUP_COMMUNITY_CLOSE.replace(
                '%DISPLAYNAME%',
                community.displayName
              )}
              checkboxText={'I understand that everything will be deleted.'}
              buttonProps={{
                cancelText: 'Cancel',
                okText: 'Delete community',
              }}
              onClickAction={closeCommunity}
            />,
          ]}
          {!community.isMember && (
            <div>
              <TooltipHost
                content={
                  community.communityType === 'Open'
                    ? constants.JOIN
                    : constants.REQUEST
                }
                directionalHint={DirectionalHint.leftTopEdge}
              >
                <DefaultButton
                  iconProps={{
                    iconName: 'AddFriend',
                    styles: {
                      root: {
                        fontSize: 24,
                        height: 24,
                        width: 24,
                        lineHeight: 24,
                        backgroundColor: '#eaeaea',
                        boxSizing: 'content-box',
                        marginLeft: 0,
                        padding: 8,
                        borderRadius: 8
                      }
                    }
                  }}
                  text={
                    !profile.isGuest &&
                    community.communityType === 'Open'
                      ? 'Join this community'
                      : 'Request to join this community'
                  }
                  ariaLabel={
                    community.communityType === 'Open'
                      ? constants.JOIN
                      : constants.REQUEST
                  }
                  onClick={requestToJoin}
                  disabled={!community.isCreated}
                  styles={{
                    root: {
                      backgroundColor: 'transparent',
                      height: 40,
                      paddingLeft: 0
                    },
                    rootHovered: {
                      backgroundColor: 'transparent'
                    }
                  }}
                />
              </TooltipHost>
            </div>
          )}
          {showManagementTools && (
            <div>
              <hr />
              <PrimaryButton
                text='View community details and membership'
                ariaLabel='View community details and membership'
                primary={true}
                onClick={manageCommunity}
                styles={ isSidePanel ? {
                  root: {
                    borderRadius: 6
                  }
                }:{}}
              />
            </div>
          )}
        </React.Fragment>
      ) : (
        <p>{constants.PROCESSING}</p>
      )}
    </>
  );
};

export default CommunityActionsComponent;